import React, { Component } from "react";
import { v4 as uuidv4 } from "uuid";
import FormBuilderSidebar from "../components/formBuilder/components/FormBuilderSidebar";
import FormsContainer from "../components/formBuilder/components/FormsContainer";
import { FormBuilderObjects } from "../variables/formBuilderData";
import FormInputConfig from "../components/formBuilder/components/FormInputConfig";
import Responsive from "../components/Responsive";
import { conditionalWidth, translate } from "../utils/useful";
import FormBuilderTopbar from "../components/formBuilder/components/FormBuilderTopbar";
import html2canvas from 'html2canvas'
import TextInput from "../components/inputs/TextInput";
import SidebarView from "../components/SidebarView";
import ButtonAnimated from "../components/buttons/ButtonAnimated";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../stores/actionsList';

class FormBuilder extends Component {
    state = {
        currentPage: 0,
        formContent: [
            {
                //Page
                pageId: uuidv4(),
                pageContent: [{
                    //Section
                    sectionId: uuidv4(),
                    sectionContent: [
                        {
                            rowId: uuidv4(),
                            rowContent: [
                                // {

                                //     columnId: uuidv4(),
                                //     columnContent: [

                                //     ],
                                // }
                            ],
                        }
                    ]
                }]

            }
        ],
        collectionName: null,
        // formsRows: [
        //     {
        //         rowId: uuidv4(),
        //         rowContent: [],
        //     }
        // ],
        count: 0,
        // formItems: {
        //     Headline: {
        //         itemName: "Headline",
        //         inputType: "Headline"
        //     },
        //     Copy: {
        //         itemName: "Copy",
        //         inputType: "Copy"
        //     },
        //     Image: {
        //         itemName: "Image",
        //         inputType: "Image"
        //     },
        //     Slideshow: {
        //         itemName: "Slideshow",
        //         inputType: "Slideshow"
        //     },
        //     Quote: {
        //         itemName: "Quote",
        //         inputType: "Quote"
        //     }
        // },

        showhandlers: false
    };


    componentDidMount() {
   
        let initData = this.state.formContent
        if (Array.isArray(this.props.initData) && !this.props.initData[0].pageContent) {
            initData = [{
                pageId: uuidv4(),
                pageContent: [{
                    sectionId: uuidv4(),
                    sectionContent: [
                    ]
                }]

            }]
            this.props.initData.map((element, index) => {
                initData[0].pageContent[0].sectionContent[index] = {
                    rowId: uuidv4(),
                    rowContent: [element]
                }
            })

        }
        else if(this.props.initData) {
            initData = this.props.initData
        }
        // console.log('initdata', initData)
        this.setState({ formContent: initData })


        if (this.props.collectionName) {
            this.setState({ collectionName: this.props.collectionName }, () => {
                if (this.props.setHeader) {
                    this.props.setHeader("dummy", 1)
                }
            })
        }

        if (this.props.setHeader) {
            // this.props.setHeader("dummy",1)
            this.props.setHeader({
                'toolbar': null,
                'showToolbar': false,
                'title': this.props.page?.title,
                'subtitle': this.props.page?.subtitle,
                topHeaderComponent: this.topHeaderComponent,
                headerIdentityComponent: this.headerIdentityComponent,
                backAction: () => this.props.changePage('')
            })
        }

    }
    getHeaders = () => {
        return this.state.formContent
    }

    headerIdentityComponent = () => {
        return (
            <div className='' >
                <input type="text" onChange={(e) => this.setName(e.target.value)} required={true} value={this.state.collectionName} className={' ' + this.props.colors?.iconInvert ? 'lightPlaceholder' : 'darkPlaceholder'} style={{ fontSize: '18px', backgroundColor: 'transparent', border: 'none', color: this.props.colors.textColor }} placeholder={translate('Insert name ...')} />
            </div>
        )
    }

    setName = (value) => {
        this.setState({ collectionName: value }, () => {
            this.props.setHeader("dummy", 1)
        })
    }

    componentDidUpdate(prevProps) {
        if (prevProps.initData != this.props.initData && this.props.initData) {
           let initData = this.state.formContent
        if (Array.isArray(this.props.initData) && !this.props.initData[0].pageContent) {
            initData = [{
                pageId: uuidv4(),
                pageContent: [{
                    sectionId: uuidv4(),
                    sectionContent: [
                    ]
                }]

            }]
            this.props.initData.map((element, index) => {
                initData[0].pageContent[0].sectionContent[index] = {
                    rowId: uuidv4(),
                    rowContent: [element]
                }
            })

        }
        else if(this.props.initData) {
            initData = this.props.initData
        }
        // console.log('initdata', initData)
        this.setState({ formContent: initData })
        }
        // console.log('formContentChange', this.state.formContent)

        // if (prevProps.data?.name != this.props.data?.name && this.props.data?.name) {
        //     this.setState({ collectionName: this.props.data.name },()=>{
        //         this.props.setHeader("dummy",1)
        //     })

        // }
        // if (prevProps.collectionName != this.props.collectionName && this.props.collectionName) {
        // }
    }

    setData = (key, value, reference, cb) => {
        if (reference == 'FormBuilder') {
            this.setState({ [key]: value }, () => {
                if (cb) {
                    cb()
                }
            })
        }
        else {
            if (this.props.setData) {
                this.props.setData(key, value, reference, () => {

                })
            }
        }
    }
    topHeaderComponent = () => {
        return (
            <div className='flexc'>

                <ButtonAnimated
                    iconwidth='24px'
                    onClick={this.save}
                    title='{{lang}}Next'
                    icon='/assets/icons/arrow-right-white.svg'
                    textColor={this.props.colors?.iconInvert ? '#fff' : '#000'}
                    invert={!this.props.colors?.iconInvert}
                    bg={this.props.colors?.iconInvert ? '#000' : '#fff'}
                />

            </div>

        )
    }

    save = () => {
        this.setState({ isLoadingData: true })
        if (this.state.collectionName?.trim() == null || !this.state.collectionName?.trim()) {
            this.setState({ collectionName: null }, () => {
                this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.NameRequired', description: '{{lang}}errors.NameRequired' })
                this.setState({ isLoadingData: false })
            })
        }
        // if (content.length == 0) {
        //     this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.ContentEmpty', description: '{{lang}}errors.ContentEmpty' })
        //     this.setState({ isLoadingData: false })
        // }
        if (this.state.collectionName && this.state.collectionName.trim() != null
            // && content.length != 0
        ) {
            this.onSave()
        }
    }


    onSave = () => {
        this.setState({ isLoadingData: false })

        if (this.props.onSave) {
            let data = JSON.parse(JSON.stringify(this.state.formContent))
            let collectionName = this.state.collectionName
            this.props.onSave(data, collectionName)
        }
    }
    changeValue = (key, value) => {
        this.setState({ [key]: value })
    }
    render() {
        const { formsRows, formItems, showhandlers } = this.state;
        let page = this.state.formContent[this.state.currentPage]
        return (
            <div ref={el => this.formBuilder = el} className={"form-container bg-white h-100 " + (conditionalWidth(this.props.width, { xs: ' d-block  ', md: ' d-flex ' }))}>

                <SidebarView width={this.props.width} ref={el => this.infoSidebar = el} hideOverlay={false} widthCondition={{ xs: "60%", sm: "50%", md: '50%', lg: "50%", xl: "40%" }} onClose={this.onClose} left={50} >


                    {this.state.showConfig && (
                        <FormInputConfig ref={el => this.FormInputConfig = el} updateInputData={this.updateInputData} headers={this.state.currentInput?.headers} initData={this.state.currentData?.information} input={this.state.currentInput} submit={this.submitConfig} />
                    )}
                    <button className={"close-hide sideHandler blur-back flexcc "} onClick={e => this.openInputConfig(null)}>
                        <img src="/images/next-2.png" width="20px" alt="" />
                    </button>

                </SidebarView>


                <div className={"h-100 " + conditionalWidth(this.props.width, { xs: ' d-none  ', md: '' })}>
                    <Responsive width={this.props.width} height={'100%'} media={{ xs: 'none', sm: 'none', md: '200px' }}>
                        <FormBuilderSidebar
                            onSave={this.onSave}
                            formItems={Object.values(FormBuilderObjects)}
                            showhandlers={() => this.setState({ showhandlers: true })}
                            hideHandlers={() => this.setState({ showhandlers: false })}
                            lastStage={this.props.lastStage}
                            lastStagePage={this.props.lastStagePage}
                            saveTitle={this.props.saveTitle}
                            language={this.props.language}
                        />
                    </Responsive>
                </div>
                <div className={"position-sticky w-100 " + (conditionalWidth(this.props.width, { xs: '', md: ' d-none ' }))} style={{ top: 0, zIndex: 1 }}>

                    <FormBuilderTopbar
                        formItems={Object.values(FormBuilderObjects)}
                        showhandlers={() => this.setState({ showhandlers: true })}
                        hideHandlers={() => this.setState({ showhandlers: false })}
                    />
                </div>


                {/* <div className={"sidePanel " + (conditionalWidth(this.props.width, { xs: '', lg: ' d-none ' })) + " " + (this.state.sideOpen ? '' : 'sideClose')} style={{ width: conditionalWidth(this.props.width, { xs: "60%", sm: "50%", md: '60%', lg: "50%", xl: "40%" }) }}>
                    <div className='sidePanel-content h-100 blur-back' > */}


                {/* 
                    </div>

                </div> */}

                {/* <div onClick={() => { this.openInputConfig(null) }} className={'position-fixed top-0 left-0 w-100 h-100 fadein ' + (this.state.sideOpen ? '' : 'd-none')} style={{ backgroundColor: '#10101040' }}>

                </div> */}


                <Responsive width={this.props.width} className={'flex-1'} media={{ xs: '12', md: '12', lg: '8', xl: '8' }}>
                    <div className="w-100 h-100 scroll-no-scrollbar pt-1">

                        {/* <div className="w-100 px-4 pt-3 flexcb"> */}
                        {/* <div className="px-2 w-100">
                                <div className='flexcc blue-box-border-h px-2 py-2 br-10 w-100'>
                                    <TextInput data={this.state.collectionName} changeValue={this.changeValue} header={{ key: 'collectionName', information: { rows: 1, placeholder: '{{lang}}Form Name' }, }} />
                                </div>
                            </div> */}
                        {/* <p className="text-semibold text-semibig">{translate('Form Name')}</p> */}

                        {/* <button onClick={() => { }} className='px-1 py-1  flexcc mt-1' style={{ filter: !this.state.type == null ? 'saturate(20%) ' : '', background: 'linear-gradient(to right,#9564FE, #7064FE)', borderRadius: 8, color: '#fff', transition: 'all 0.5s' }}>
                        <p className='text-small text-semibold mld-3 mrd-3 ' style={{ whiteSpace: 'nowrap' }}>{translate("Save Form")}</p>
                        <div className='flexcc mld-3 p-1' style={{ background: 'linear-gradient(to right, #ffffff10, #ffffff20)', borderRadius: 8 }}>
                            <img className='invert' src='/assets/icons/useful/save.svg' height={18} />
                        </div>
                    </button> */}

                        {/* </div> */}

                        {/* {this.state.formContent.map((page, index) => {
                        return (
                            <div>{page.id}</div>
                        )
                    })} */}


                        <FormsContainer
                            ref={el => this.formsContainer = el}
                            inputClass={'bordered-input'}
                            formClass={'bordered-form'}
                            pageContent={page.pageContent}
                            pageIndex={this.state.currentPage}
                            pageId={page.pageId}
                            addnewItem={this.addnewItem}
                            openInputConfig={this.openInputConfig}
                            changeInputPosition={this.changeInputPosition}
                            showhandlers={showhandlers}
                            showhandlersFunc={() =>
                                this.setState({ showhandlers: true })
                            }
                            hideHandlersFunc={() =>
                                this.setState({ showhandlers: false })
                            }
                            deleteInput={this.deleteInput}
                        // hideHandlers={() => this.setState({ showhandlers: false })}
                        />


                    </div>

                </Responsive>


                <Responsive width={this.props.width} height={'100%'} media={{ xs: 'none', lg: '4', xl: '4' }}>

                    <div className="w-100 w-100 h-100 scroll-no-scrollbar px-2" style={{ boxShadow: '0px 0px 10px #00000010' }}>
                        {(this.state.currentInput && this.state.showConfig) ? (
                            <FormInputConfig ref={el => this.FormInputConfig1 = el} updateInputData={this.updateInputData} headers={this.state.currentInput?.headers} initData={this.state.currentData?.information} input={this.state.currentInput} submit={this.submitConfig} />
                        ) : (
                            <div className="flexcc flex-column py-5">
                                <img src="/assets/icons/useful/empty.png" height={70} />
                                <p className="mt-3 text-semibold text-semibig">{translate('No Input is selected')}</p>
                                <p className="mt-1 text-small color-gray-2 text-center" style={{ maxWidth: 200 }}>{translate("Select an input to customize it's information")}</p>

                            </div>
                        )}
                    </div>
                </Responsive>

            </div>
        );
    }



    setFormContent = (formContent) => {

        this.setState({ formContent }, () => {
            if (this.props.changeValue) {
                if (this.state.formContent && this.state.formContent[0]?.pageContent && this.state.formContent[0]?.pageContent[0]) {
                    let questions = []
                    this.state.formContent[0].pageContent[0].sectionContent.map((prop) => {
                        prop.rowContent.map((element) => {
                            questions.push({ ...element })
                        })
                    })

                    // this.props.postRecord(() => {
                    // let scoreHeader = []
                    // questions.forEach(el => {
                    //     scoreHeader.push(
                    //         { key: `${el.key}`, id: `${el.id}`, type: 'NumberInput', information: { disabled: false, label: "{{lang}}Score", placeholder: "{{lang}}Score" } }
                    //     )
                    // });
                    // this.props.setData({ 'values.questions': questions }, () => {
                    //     console.log('scoreHeader11',scoreHeader)
                    //     this.props.setData({ 'values.scoreHeader': scoreHeader }, () => {
                    //         this.props.changeStage('answerSheet')
                    //         // this.submitModal.hideModal()
                    //     })
                    // })
                    // })
                    this.props.changeValue(questions)
                }
            }
        })

    }




    addnewItem = (key, rowId, sectionId, pageId, direction, inputIndex) => {
        let foundInput = JSON.parse(JSON.stringify(FormBuilderObjects[key]));
        let formContent = JSON.parse(JSON.stringify(this.state.formContent))
        let pageIndex
        let sectionIndex

        formContent.forEach((page, index) => {
            if (page.pageId == pageId) {
                pageIndex = index
            }
        });
        if (pageIndex != null) {
            formContent[pageIndex].pageContent.forEach((section, index) => {
                if (section.sectionId == sectionId) {
                    sectionIndex = index
                }
            });
        }

        if (pageIndex != null && sectionId != null) {

            let formsRows = [...formContent[pageIndex].pageContent[sectionIndex].sectionContent];
            let foundRow = formsRows.find((row) => row.rowId == rowId);
            let foundRowIndex = formsRows.indexOf(foundRow);
            let placehoder = '{{lang}}' + foundInput?.label
            foundInput.headers.forEach(header => {
                if (header.key == 'placeholder' && header.information.defaultValue) {
                    placehoder = header.information.defaultValue
                }
            });
            let information = { label: foundInput?.label, placeholder: placehoder, disabled: false }
            let keyId = uuidv4()
            let newRowInput = { id: keyId, key: keyId, type: foundInput?.type, information: information };
            let newRow = {
                rowId: uuidv4(),
                rowContent: []
            };
            if (!direction) {
                foundRow.rowContent.push(JSON.parse(JSON.stringify(newRowInput)));
            }
            if (direction) {
                switch (direction) {
                    case "top":
                        newRow.rowContent.push(JSON.parse(JSON.stringify(newRowInput)));
                        formsRows.unshift(newRow);
                        break;
                    case "bottom":
                        newRow.rowContent.push(JSON.parse(JSON.stringify(newRowInput)));
                        formsRows.splice(foundRowIndex + 1, 0, newRow);
                        // formsRows.push(newRow)
                        break;
                    case 'left':
                        foundRow.rowContent.unshift(JSON.parse(JSON.stringify(newRowInput)));
                        break;
                    case 'right':
                        foundRow.rowContent.splice(inputIndex + 1, 0, JSON.parse(JSON.stringify(newRowInput)))
                        break
                    default:
                        break;
                }
            }
            formContent[pageIndex].pageContent[sectionIndex].sectionContent = JSON.parse(JSON.stringify(formsRows))

            this.setFormContent(JSON.parse(JSON.stringify(formContent)))
            // this.setState({ formContent: JSON.parse(JSON.stringify(formContent)) }, () => {
            //     // console.log('formContent', this.state.formContent)
            // });
        }
    };

    changeInputPosition = (inputId, type, rowId, sectionId, pageId, DRowID, DSectionId, DPageId, direction, inputIndex) => {
        let formContent = JSON.parse(JSON.stringify(this.state.formContent))
        let pageIndex
        let sectionIndex
        let DPageIndex
        let DSectionIndex
        formContent.forEach((page, index) => {
            if (page.pageId == pageId) {
                pageIndex = index
            }
        });
        formContent.forEach((page, index) => {
            if (page.pageId == DPageId) {
                DPageIndex = index
            }
        });

        if (pageIndex != null) {
            formContent[pageIndex].pageContent.forEach((section, index) => {
                if (section.sectionId == sectionId) {
                    sectionIndex = index
                }
            });
        }
        if (DPageIndex != null) {
            formContent[DPageIndex].pageContent.forEach((section, index) => {
                if (section.sectionId == DSectionId) {
                    DSectionIndex = index
                }
            });
        }
        if (pageIndex != null && sectionIndex != null && DPageIndex != null && DSectionIndex != null) {
            let formsRows = [...formContent[pageIndex].pageContent[sectionIndex].sectionContent];
            let DformsRows = [...formContent[DPageIndex].pageContent[DSectionIndex].sectionContent];
            let foundRow = formsRows.find((row) => row.rowId == rowId)
            let destinationRow = DformsRows.find((row) => row.rowId == DRowID)
            let destinationRowIndex = DformsRows.indexOf(destinationRow)
            let foundInput = foundRow.rowContent.find((input) => input.id == inputId);
            let foundInputIndex = foundRow.rowContent.indexOf(foundInput);
            foundRow.rowContent.splice(foundInputIndex, 1);
            let foundRowIndex = formsRows.indexOf(foundRow);
            // destinationRow.rowContent.splice()
            // console.log('foundInputis', foundInput)
            let newRowInput = foundInput;
            let newRow = {
                rowId: uuidv4(),
                rowContent: []
            };
            switch (direction) {
                case "top":
                    if (foundRowIndex == destinationRowIndex) return;
                    if (foundRow.rowContent.length == 0) {
                        formsRows.splice(foundRowIndex, 1)
                    }
                    newRow.rowContent.push(newRowInput);
                    formsRows.unshift(newRow);
                    break;
                case "bottom":
                    if (foundRow.rowContent.length == 0) {
                        newRow.rowContent.push(foundInput);
                        formsRows.splice(foundRowIndex, 1)
                        formsRows.splice(destinationRowIndex, 0, newRow);
                    }
                    else {
                        newRow.rowContent.push(foundInput);
                        formsRows.splice(destinationRowIndex + 1, 0, newRow);
                    }
                    break;
                case 'left':
                    destinationRow.rowContent.unshift(foundInput);
                    if (foundRow.rowContent.length == 0) {
                        formsRows.splice(foundRowIndex, 1);
                    }
                    break;
                case 'right':
                    destinationRow.rowContent.splice(inputIndex + 1, 0, foundInput)
                    if (foundRow.rowContent.length == 0) {
                        formsRows.splice(foundRowIndex, 1);
                    }
                    break
                default:
                    break;
            }
            // DformsRows[destinationRowIndex] = destinationRow
            formContent[pageIndex].pageContent[sectionIndex].sectionContent = formsRows
            // formContent[DPageIndex].pageContent[DSectionIndex].sectionContent = DformsRows
            // this.setState({ formContent }, () => {
            // })
            this.setFormContent(formContent)

        }
    };

    deleteInput = (inputId, rowid, sectionId, pageId) => {
        let pageIndex
        let sectionIndex
        let formContent = JSON.parse(JSON.stringify(this.state.formContent))
        formContent.forEach((page, index) => {
            if (page.pageId == pageId) {
                pageIndex = index
            }
        });
        if (pageIndex != null) {
            formContent[pageIndex].pageContent.forEach((section, index) => {
                if (section.sectionId == sectionId) {
                    sectionIndex = index
                }
            });
        }
        if (pageIndex != null && sectionId != null) {
            let formsRows = [...formContent[pageIndex].pageContent[sectionIndex].sectionContent];
            let foundRow = formsRows.find(row => row.rowId == rowid)
            let foundRowIndex = formsRows.indexOf(foundRow);
            let inputIndex = formsRows[foundRowIndex].rowContent.indexOf(foundRow.rowContent.find(input => input.id == inputId));
            let removedHeader = formsRows[foundRowIndex].rowContent[inputIndex]
            formsRows[foundRowIndex].rowContent.splice(inputIndex, 1)
            if (foundRow.rowContent.length == 0) {
                formsRows.splice(foundRowIndex, 1)
            }
            let newRow = {
                rowId: uuidv4(),
                rowContent: []
            };
            if (formsRows.length == 0) {
                formsRows.push(newRow)
            }
            formContent[pageIndex].pageContent[sectionIndex].sectionContent = formsRows
            // this.setState({ formContent }, () => {
            // })
            this.setFormContent(formContent)

            if (removedHeader.key == this.state.currentData?.key) {
                this.openInputConfig(null)
            }
        }
    }

    openInputConfig = (header) => {
        if (this.FormInputConfig) {
            this.FormInputConfig.validateForm((isvalid) => {
                if (!isvalid) {
                    return
                }
                this.openInputConfigAct(header)
            })
        } else {
            this.openInputConfigAct(header)
        }
    }

    openInputConfigAct(header) {
        // console.log('openInputConfigAct')
        let sideOpen = header != null ? true : false
        if (sideOpen && header && FormBuilderObjects[header.type]) {
            let data = null
            let formContent = JSON.parse(JSON.stringify(this.state.formContent))

            formContent.forEach(page => {
                page.pageContent.forEach(section => {
                    section.sectionContent.forEach(row => {
                        row.rowContent.forEach(input => {
                            if (input.key == header.key) {
                                data = { ...input }
                            }
                        });
                    });
                });
            })
            this.infoSidebar.open()
            this.setState({ sideOpen, currentInput: FormBuilderObjects[header.type], currentHeader: header, currentData: data, showConfig: false }, () => {
                this.setState({ showConfig: true })
            })
        } else {
            this.infoSidebar.close()
            this.setState({ sideOpen: false, currentInput: null, showConfig: false }, () => {
                this.setState({ showConfig: true })
            })
        }
    }




    submitConfig = (header) => {

        let data = this.state.currentData
        let currentInput = this.state.currentInput
        let currentHeader = this.state.currentHeader


        let formContent = JSON.parse(JSON.stringify(this.state.formContent))
        formContent.forEach(page => {
            page.pageContent.forEach(section => {
                section.sectionContent.forEach(row => {
                    row.rowContent.forEach(input => {

                        console.log(input.key)
                        console.log(currentHeader.key)

                        if (input.key == currentHeader.key) {
                            // data = { ...input }
                            console.log(input)
                            input.information = data.information
                        }
                    });
                });
            });
        })
        this.infoSidebar.close()

        this.setFormContent(formContent)

        this.setState({ sideOpen: false, showConfig: false }, () => { })

    }

    updateInputData = (key, value) => {
        let data = this.state.currentData
        data.information[key] = value

        // console.log(data)
        // console.log(key)
        // console.log(value)

        this.setState({ currentData: data })
    }
}

const mapStateToProps = state => ({ settings: state.settings, user: state.user })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps,
    null,
    { forwardRef: true }
)(FormBuilder)